import React from "react";
import PropTypes from "prop-types";

import StandardHotspot from "./StandardHotspot";
import ComponentMissing from "../../Debug/ComponentMissing";

const HotspotSwitcher = ({
  layout,
  header,
  headerType,
  headerDisplayStyle,
  headerLink,
  headerLinkType,
  secondaryLink,
  secondaryLinkType,
  subline,
  teaser,
  media,
  items,
  animation,
}) => {
  const properties = {
    header,
    headerType,
    headerDisplayStyle,
    headerLink,
    headerLinkType,
    secondaryLink,
    secondaryLinkType,
    subline,
    teaser,
    media,
    items,
    animation,
  };

  function switchHotspot() {
    switch (layout) {
      case "standard":
        return <StandardHotspot properties={properties} />;
      default:
        return <ComponentMissing type="Hotspot" subType={layout} />;
    }
  }

  return switchHotspot();
};

HotspotSwitcher.propTypes = {
  layout: PropTypes.string,
  header: PropTypes.string,
  headerType: PropTypes.string,
  headerDisplayStyle: PropTypes.string,
  headerLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  headerLinkType: PropTypes.string,
  secondaryLink: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  secondaryLinkType: PropTypes.string,
  subline: PropTypes.string,
  teaser: PropTypes.string,
  media: PropTypes.oneOfType([PropTypes.instanceOf(Object), PropTypes.string]),
  items: PropTypes.instanceOf(Array),
  animation: PropTypes.instanceOf(Object),
};

export default HotspotSwitcher;
